import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { Data2Service } from '../../../common/data2.service';
import { DateService } from '../../../common/date.service';

@Component({
	selector: 'app-drivers-calendar-filters',
	templateUrl: './drivers-calendar-filters.component.html',
	styleUrls: ['./drivers-calendar-filters.component.css'],
})
export class DriversCalendarFiltersComponent extends FiltersComponent {
	@Input() drivers: Array<any> = [];
	@Input() statuses: Array<any> = [];
	@Input() allDrivers: Array<any> = [];
	@Input() yesno: Array<any> = [];
	@Input() driverKinds: Array<any> = [];
	@Input() filters = {
		statuses: null,
		drivers: null,
		trailer: null,
		vaccinations: null,
		showDeleted: 0,
		driverKinds: null,
	};

	filtersDefault() {
		this.filtersClear();
		this.filters.statuses = ['REGULAR', 'JUMPER', 'MAYBE'];
		this.filters.driverKinds = ['2'];
	}
}
